export default __webpack_public_path__ + "static/icon-facebook-alt-85ff4e98133af6dc8aec75b419d09288.svg";